// type Props = {
//   version: string
//   setVersion: (value: string) => void
// }

// export const BrandFilter = ({ version, setVersion }: Props) => {
//   return (
//     <select className="filter-box cursor-pointer w-[186px]" value={version} onChange={(e) => setVersion(e.target.value)}>
//       <option className="filter-box-item body-s hover:subtitle-s" value="ALL">All</option>
//       <option className="filter-box-item body-s" value="ACTIVE">Current</option>
//       <option className="filter-box-item body-s" value="ARCHIVE">Previous</option>
//       <option className="filter-box-item body-s" value="DRAFT">Draft</option>
//     </select>
//   )
// }

import { useState, useRef, useEffect } from 'react'

import { IsAdmin } from 'app/IsAdmin'
import { IsNotAdmin } from 'app/IsNotAdmin'

interface Props {
  version: string
  setVersion: (value: string) => void
}

interface FilterOption {
  value: string
  label: string
}

const OPTIONS: FilterOption[] = [
  { value: 'ALL', label: 'All BVAs' },
  { value: 'ACTIVE', label: 'Current versions' },
  { value: 'ARCHIVE', label: 'Previous versions' },
  { value: 'DRAFT', label: 'Drafts' },
]

export const BrandFilter = ({ version, setVersion }: Props) => {
  const [open, setOpen] = useState(false)
  const [focusedIndex, setFocusedIndex] = useState<number>(-1)

  const dropdownRef = useRef<HTMLDivElement>(null)
  const optionRefs = useRef<(HTMLDivElement | null)[]>([])

  const selectedIndex = OPTIONS.findIndex(o => o.value === version)

  /* ---------- OUTSIDE CLICK ---------- */
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false)
        setFocusedIndex(-1)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  /* ---------- KEYBOARD NAVIGATION ---------- */
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!open && (e.key === 'ArrowDown' || e.key === 'Enter')) {
      setOpen(true)
      setFocusedIndex(selectedIndex >= 0 ? selectedIndex : 0)
      return
    }

    if (!open) return

    switch (e.key) {
      case 'Escape':
        setOpen(false)
        setFocusedIndex(-1)
        break

      case 'ArrowDown':
        e.preventDefault()
        setFocusedIndex(prev => {
          const next = prev + 1 >= OPTIONS.length ? 0 : prev + 1
          optionRefs.current[next]?.focus()
          return next
        })
        break

      case 'ArrowUp':
        e.preventDefault()
        setFocusedIndex(prev => {
          const next = prev - 1 < 0 ? OPTIONS.length - 1 : prev - 1
          optionRefs.current[next]?.focus()
          return next
        })
        break

      case 'Enter':
        if (focusedIndex >= 0) {
          setVersion(OPTIONS[focusedIndex].value)
          setOpen(false)
        }
        break
    }
  }

  return (
    <div ref={dropdownRef} className="relative inline-block text-left" onKeyDown={handleKeyDown}>
      {/* Button */}
      <button
        type="button"
        className="cursor-pointer body-s selected-filter w-[186px]"
        onClick={() => {
          setOpen(v => !v)
          setFocusedIndex(selectedIndex)
        }}
      >
        <span className="body-s whitespace-nowrap">{OPTIONS.find(o => o.value === version)?.label}</span>

        {/* Chevron */}
        <svg
          className={`w-5 h-5 ml-2 transition-transform duration-200 ${open ? '' : 'rotate-180'}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute left-0 z-20 mt-1 filter-wrapper body-s">
          {OPTIONS.map((option, index) => (
            <>
              <IsAdmin>
                <div
                  key={option.value}
                  ref={el => (optionRefs.current[index] = el)}
                  tabIndex={0}
                  onClick={() => {
                    setVersion(option.value)
                    setOpen(false)
                  }}
                  onFocus={() => setFocusedIndex(index)}
                  className={`cursor-pointer cursor-pointer filter-wrapper-item select-none outline-none
                 select-none outline-none
                ${option.value === version ? 'subtitle-s color-neutral-100' : 'color-neutral-80 body-s'}
                ${focusedIndex === index ? 'bg-gray-100' : ''}`}
                >
                  {option.label}
                </div>
              </IsAdmin>
              <IsNotAdmin>
                {option.value !== 'DRAFT' && (
                  <div
                    key={option.value}
                    ref={el => (optionRefs.current[index] = el)}
                    tabIndex={0}
                    onClick={() => {
                      setVersion(option.value)
                      setOpen(false)
                    }}
                    onFocus={() => setFocusedIndex(index)}
                    className={`cursor-pointer cursor-pointer filter-wrapper-item select-none outline-none
                 select-none outline-none
                ${option.value === version ? 'subtitle-s color-neutral-100' : 'color-neutral-80 body-s'}
                ${focusedIndex === index ? 'bg-gray-100' : ''}`}
                  >
                    {option.label}
                  </div>
                )}
              </IsNotAdmin>
            </>
          ))}
        </div>
      )}
    </div>
  )
}
